import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';

import { FeatureNeededComponent } from './feature-needed.component';

@NgModule({
    imports: [CommonModule, ModalBaseModule],
    declarations: [FeatureNeededComponent],
    exports: [FeatureNeededComponent],
})
export class FeatureNeededModule {}
